<div class="input-container">
    <ng-container *ngIf="_kiosk !== true">
        <textarea 
            class="form-control" 
            [rows]="rows"
            [name]="name" 
            [placeholder]="placeholder" 
            [value]="value" 
            [readonly]="readonly" 
            [disabled]="disabled" 
            [ngClass]="{ 'disabled': disabled }"
            (input)="onInput($event)"             
            (keyup)="onKeyUp($event)" 
            (focus)="onFocus(true)" 
            (blur)="onFocus(false)" 
            role="presentation" 
            [autocomplete]="autocomplete"
        ></textarea>
    </ng-container>
    <ng-container *ngIf="(_kiosk === true)">  
        <textarea 
            uppNgkiosk
            class="form-control"             
            data-kioskboard-type="all" 
            data-kioskboard-specialcharacters="true" 
            [rows]="rows"
            [name]="name" 
            [value]="value" 
            [placeholder]="placeholder" 
            [readonly]="readonly" 
            [disabled]="disabled" 
            [ngClass]="{ 'disabled': disabled }"
            (change)="onKiosk($event)" 
            (focus)="onFocus(true)" 
            (blur)="onFocus(false)" 
            role="presentation" 
            [autocomplete]="autocomplete"
        ></textarea>
    </ng-container>
</div>
